import React from 'react';
import styled from 'styled-components';

const Card = styled.article`
  border-radius: 24px;
  padding: 24px;
  background: rgba(20, 22, 35, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 18px 34px rgba(0, 0, 0, 0.4);
`;

const Top = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

const Logo = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 16px;
  object-fit: cover;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 18px;
  color: ${({ theme }) => theme.text_primary};
`;

const Company = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.text_secondary};
`;

const Date = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.text_secondary};
  font-size: 14px;
`;

const Meta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  color: ${({ theme }) => theme.text_secondary};
  font-size: 14px;
`;

const Badge = styled.span`
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(133, 76, 230, 0.15);
  color: ${({ theme }) => theme.primary};
  font-size: 12px;
`;

const SkillList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

const Skill = styled.span`
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.05);
  color: ${({ theme }) => theme.text_primary};
  font-size: 12px;
`;

const CredentialLink = styled.a`
  margin-top: 4px;
  width: fit-content;
  text-decoration: none;
  color: ${({ theme }) => theme.primary};
  font-weight: 600;
  font-size: 14px;
`;

const CertificateCard = ({ certificate }) => (
  <Card>
    <Top>
      <Logo src={certificate.img} alt={certificate.company} />
      <Body>
        <Title>{certificate.name}</Title>
        <Company>{certificate.company}</Company>
        <Date>Issued on {certificate.date}</Date>
      </Body>
    </Top>
    {certificate.certID && (
      <Meta>
        Certificate ID
        <Badge>{certificate.certID}</Badge>
      </Meta>
    )}
    {certificate.skills && (
      <SkillList>
        {certificate.skills.map((skill) => (
          <Skill key={skill}>{skill}</Skill>
        ))}
      </SkillList>
    )}
    {certificate.doc && (
      <CredentialLink href={certificate.doc} target="_blank" rel="noreferrer">
        View credential →
      </CredentialLink>
    )}
  </Card>
);

export default CertificateCard;
